import { AssistantField } from '@kizenapps/engine';
import { ApiKeyBlock } from './ApiKeyBlock';
import { BooleanBlock } from './BooleanBlock';
import { ContainerBlock } from './ContainerBlock';
import { CustomObjectBlock } from './CustomObjectBlock';
import { DescriptionBlock } from './DescriptionBlock';
import { FieldBlock } from './FieldBlock';
import { InvalidBlock } from './InvalidBlock';
import { NumberBlock } from './NumberBlock';
import { RadioBlock } from './RadioBlock';
import { SelectBlock } from './SelectBlock';
import { TextBlock } from './TextBlock';
import { QRBlock } from './QRBlock';
import { ImageBlock } from './ImageBlock';
import { LinkBlock } from './LinkBlock';

// Partial: the engine's field types can outpace this map; unknown types render InvalidBlock
export const fieldTypeComponents: Partial<
  Record<AssistantField['type'], React.FC<any>>
> = {
  container: ContainerBlock,
  custom_object: CustomObjectBlock,
  field: FieldBlock,
  text: TextBlock,
  description: DescriptionBlock,
  number: NumberBlock,
  select: SelectBlock,
  radio: RadioBlock,
  api_key: ApiKeyBlock,
  boolean: BooleanBlock,
  qr: QRBlock,
  image: ImageBlock,
  link: LinkBlock,
};

export const SetupAssistantRow = ({
  field,
  pluginApiName,
  disabled = false,
  disableDynamicFields = false,
}: {
  field: AssistantField;
  pluginApiName: string;
  disabled?: boolean;
  disableDynamicFields?: boolean;
}) => {
  const FieldComponent: React.FC<any> =
    fieldTypeComponents[field.type] || InvalidBlock;

  return (
    <FieldComponent
      field={field}
      key={field.key}
      pluginApiName={pluginApiName}
      disabled={disabled}
      disabledIfDynamic={disableDynamicFields}
    />
  );
};
